var map = {
	"./black.png": 30515,
	"./blue.png": 16360,
	"./brown.png": 51922,
	"./darkGreen.png": 38299,
	"./gray.png": 56625,
	"./green.png": 85275,
	"./orange.png": 1326,
	"./pink.png": 66184,
	"./red.png": 94811,
	"./violet.png": 99225
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82667;